import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"

export default class extends Controller {
  static targets = ["number"]
  static values = { url: String }

  connect() {
    this.#sortable = Sortable.create(this.element, {
      animation: 150,
      handle: ".funnel-step-sort-handle",
      ghostClass: "funnel-step-row--ghost",
      chosenClass: "funnel-step-row--chosen",
      onEnd: this.#onEnd
    })

    this.#updateNumbers()
  }

  disconnect() {
    this.#sortable?.destroy()
  }

  #onEnd = async ({ oldIndex, newIndex }) => {
    this.#updateNumbers()
    if (oldIndex === newIndex) return

    try {
      const response = await fetch(this.urlValue, {
        method: "PATCH",
        headers: {
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content,
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ ids: this.#orderedIds() })
      })

      if (!response.ok) this.#reload()
    } catch {
      this.#reload()
    }
  }

  #orderedIds() {
    return [...this.element.querySelectorAll("[data-step-id]")]
      .map(row => row.dataset.stepId)
      .filter(Boolean)
  }

  #updateNumbers() {
    this.numberTargets.forEach((target, index) => {
      target.textContent = index + 1
    })
  }

  #reload() {
    if (window.Turbo) {
      Turbo.visit(window.location.href)
    } else {
      window.location.reload()
    }
  }

  #sortable = null
}
